const getBlogType = (type: string): string => {
  switch (type) {
    case 'blog_post':
      return '/blog';
    case 'press_post':
      return '/press';
    default:
      return '/blog';
  }
};

export default getBlogType;
